import { useState } from "react";
import { useAppContext } from "../../../context/AuthContext";
import { UserController, UserControllerType } from "../../../controller/user/UserController";
import LabelsContext from "../../../lang/LabelsContext";
import MessageType from "../../../utils/MessageType";
import { handleErrorMessage, useEffectOnce } from "../../../utils/Utils";

interface AllReviewersServiceType {
  reviewerEdit: any;
  setReviewerEdit: any;
  reviewerList: any;
  updateExpertise: Function;
  handleOpenDialog: any;
  handleCloseDialog: any;
  openDialog: any;
  saveReviewer: Function;
  updateSeniority: Function;
}

export default function AllReviewersService(): AllReviewersServiceType {
  const { showMessage } = useAppContext();
  const { Labels } = LabelsContext();
  const {
    axiosUpdateExpertise,
    axiosGetReviewerList,
    axiosSaveReviewer,
    axiosUpdateUserSeniority,
  }: UserControllerType = UserController();
  const [reviewerList, setReviewerList] = useState<any[]>([]);
  const [reviewerEdit, setReviewerEdit] = useState<any>(null);
  const [openDialog, setOpenDialog] = useState(false);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  useEffectOnce(() => {
    getReviewerList();
  });

  const getReviewerList = () => {
    axiosGetReviewerList()
      .then((result: any) => {
        setReviewerList(result.data);
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  const updateExpertise = (reviewer: any) => {
    const expertiseDto = { expertise: reviewer.areasOfExpertise };
    axiosUpdateExpertise(reviewer.id, expertiseDto)
      .then((response: any) => {
        getReviewerList();
        showMessage(Labels.SUCCESSFULLY_ADDED, MessageType.SUCCESS);
        handleCloseDialog();
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  const saveReviewer = (reviewer: any) => {
    axiosSaveReviewer(reviewer)
      .then((response: any) => {
        getReviewerList();
        showMessage(Labels.SUCCESSFULLY_ADDED, MessageType.SUCCESS);
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  const updateSeniority = (id: any, seniority: string) => {
    axiosUpdateUserSeniority(id, seniority)
      .then((response: any) => {
        getReviewerList();
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  return {
    reviewerList,
    updateExpertise,
    openDialog,
    handleOpenDialog,
    handleCloseDialog,
    reviewerEdit,
    setReviewerEdit,
    saveReviewer,
    updateSeniority,
  };
}

export type { AllReviewersServiceType };
